import Swiper, { Navigation } from "swiper"
Swiper.use([Navigation])
export default new (class ProductCarousel {
    constructor() {
        this.sliderContainerSelector = "carousel-product"
        this.sliderNextSelector = "carousel-product-next"
        this.sliderPrevSelector = "carousel-product-prev"
        this.handler()
    }

    handler() {
        const slider = document.querySelector(`.${this.sliderContainerSelector}`)

        if (!slider) return

        document.addEventListener("DOMContentLoaded", () => {
            this.init()
        })
    }

    init() {
        document.querySelectorAll(`.slider:not(.slider-product-one) .${this.sliderContainerSelector}`).forEach((item) => {
            if (item.classList.contains('swiper-initialized')) return;
            new Swiper(item, {
                slidesPerView: 4,
                spaceBetween: 16,
                navigation: {
                    nextEl: item.parentElement.querySelector(`.${this.sliderNextSelector}`),
                    prevEl: item.parentElement.querySelector(`.${this.sliderPrevSelector}`),
                },
                centerInsufficientSlides: true,
                breakpoints: {
                    300: {
                        // slidesPerView: 1.95,
                        slidesPerView: 2,
                        spaceBetween: 8,
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 8,
                    },
                    992: {
                        slidesPerView: 3,
                        spaceBetween: 16,
                    },
                    1280: {
                        slidesPerView: 'auto',
                        spaceBetween: 16,
                    },
                    1440: {
                        slidesPerView: 4,
                        spaceBetween: 16,
                    },
                    1641: {
                        slidesPerView: 4.5,
                        spaceBetween: 16,
                    },
                },
            })
        })
        document.querySelectorAll(`.slider.slider-product-one .${this.sliderContainerSelector}`).forEach((item) => {
            if (item.classList.contains("swiper-initialized")) return;
            new Swiper(item, {
                slidesPerView: 4,
                spaceBetween: 16,
                navigation: {
                    nextEl: item.parentElement.querySelector(`.${this.sliderNextSelector}`),
                    prevEl: item.parentElement.querySelector(`.${this.sliderPrevSelector}`),
                },
                centerInsufficientSlides: true,
                breakpoints: {
                    300: {
                        // slidesPerView: 1.95,
                        slidesPerView: item.closest('.slider-search') ? 1.90 : 2,
                        spaceBetween: 8,
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 8,
                    },
                    992: {
                        slidesPerView: 3,
                        spaceBetween: 16,
                    },
                    1280: {
                        slidesPerView: 'auto',
                        spaceBetween: 16,
                    },
                    1440: {
                        slidesPerView: 4,
                        spaceBetween: 16,
                    },
                },
            })
        })
    }
})()
